export const Custom = {
  colorPrimary: "#0097B2", //005ce8 //7D23EB
  colorError: "#dc3545",
  colorSuccess: "#28a745",
  borderRadius: 5,
  borderColor: "#f0f0f0",
  fontFamily: "sans-serif",
  colorLight: "#949494",
  colorBgContainer: "#fff",
  colorBg: "#f5f5f5",
  colorBgLayout: "#fff",
  Button: {
    borderRadius: 5,
  },
  Input: {
    borderRadius: 5,
  },
  Select: {
    borderRadius: 5,
  },
  Textarea: {
    borderRadius: 5,
  },
  Checkbox: {
    borderRadius: 5,
  },
  CheckboxGroup: {
    borderRadius: 5,
  },
  InputNumber: {
    borderRadius: 5,
  },
  Layout: {
    Header: {},
    Menu: {},
  },
};

export const Styles = {
  colorPrimary: "#0097B2",
  colorBlue: "#005ce8",
  colorError: "#dc3545",
  colorSuccess: "#28a745",
  theme_bg: "#f5f5f5",
  borderColor: "#f0f0f0",
  gray: "#858a99",
  colorLight: "#949494",
  fontFamily: "Poppins-Regular",
  input_size: "large",
  table_size: "middle",
};
